import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingAppointments = ({ appointments, onJoinMeeting, onReschedule }) => {
  const formatAppointmentTime = (dateTime) => {
    const date = new Date(dateTime);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow?.setDate(tomorrow?.getDate() + 1);
    
    const timeString = date?.toLocaleTimeString('fa-IR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    
    if (date?.toDateString() === today?.toDateString()) {
      return `امروز - ${timeString}`;
    } else if (date?.toDateString() === tomorrow?.toDateString()) {
      return `فردا - ${timeString}`;
    } else {
      return `${date?.toLocaleDateString('fa-IR')} - ${timeString}`;
    }
  };

  const getTimeUntilAppointment = (dateTime) => {
    const now = new Date();
    const appointmentTime = new Date(dateTime);
    const diffMinutes = Math.floor((appointmentTime - now) / (1000 * 60));
    
    if (diffMinutes <= 0) return 'شروع شده';
    if (diffMinutes < 60) return `${diffMinutes} دقیقه دیگر`;
    
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} ساعت دیگر`;
    
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} روز دیگر`;
  };

  const isAppointmentSoon = (dateTime) => {
    const now = new Date();
    const appointmentTime = new Date(dateTime);
    const diffMinutes = (appointmentTime - now) / (1000 * 60);
    return diffMinutes <= 30 && diffMinutes > 0;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-card-foreground">قرارهای آینده</h3>
        <button className="text-sm text-primary hover:text-primary/80 transition-colors">
          مشاهده تقویم
        </button>
      </div>
      <div className="space-y-4">
        {appointments?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Calendar" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">قراری برنامه‌ریزی نشده</p>
          </div>
        ) : (
          appointments?.map((appointment) => (
            <div 
              key={appointment?.id} 
              className={`border rounded-lg p-4 transition-all duration-200 ${
                isAppointmentSoon(appointment?.dateTime) 
                  ? 'border-warning bg-warning/5' :'border-border hover:border-primary/50'
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-reverse space-x-3">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                    <Icon name="User" size={16} className="text-primary" />
                  </div>
                  <div>
                    <h4 className="font-medium text-card-foreground">{appointment?.clientName}</h4>
                    <p className="text-sm text-muted-foreground">{appointment?.type}</p>
                  </div>
                </div>
                
                {isAppointmentSoon(appointment?.dateTime) && (
                  <span className="px-2 py-1 bg-warning/20 text-warning text-xs rounded-full font-medium">
                    نزدیک است
                  </span>
                )}
              </div>

              <div className="flex items-center justify-between text-sm mb-3">
                <div className="flex items-center text-muted-foreground">
                  <Icon name="Clock" size={14} className="ml-1" />
                  {formatAppointmentTime(appointment?.dateTime)}
                </div>
                <div className="text-muted-foreground">
                  {getTimeUntilAppointment(appointment?.dateTime)}
                </div>
              </div>

              <div className="flex items-center space-x-reverse space-x-2">
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => onJoinMeeting(appointment?.id)}
                  iconName="Video"
                  iconPosition="right"
                  disabled={new Date(appointment.dateTime) > new Date(Date.now() + 10 * 60 * 1000)}
                  className="flex-1"
                >
                  پیوستن
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onReschedule(appointment?.id)}
                  iconName="Calendar"
                  iconPosition="right"
                  className="flex-1"
                >
                  تغییر زمان
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UpcomingAppointments;